import moment from "moment";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { addEmployeesToModelThatHasBag } from "../../../infrastructure/repository/benefit-models-repository";
import { hideModal } from "../../commons/hide-modal";
import { findEmployeesWithFields } from "../../../infrastructure/employees-cache";
import { showErrorMessage } from "../../commons/show-error-message";
import { translate as t } from "../../../infrastructure/translate/localization";
import renderDeliverBagToEmployeesModal from "../../../infrastructure/renders/DeliverBagToEmployeesModal/render-deliver-bag-to-employees-modal";

export async function deliverBagToEmployees({
  targetModel,
  employees,
  activeBags,
  onConfirm,
  navigateWhenDoneTo,
}) {
  const employeesToIncludeInBag = employees.map(({ email }) => email);
  const companyId = await findCompanyId();
  const activeBagLimitAmount = activeBags?.[0]?.limitAmount
    ? MonetaryAmount.ofCurrency(activeBags[0].limitAmount)
    : MonetaryAmount.ZERO;
  const targetBag = activeBags?.[0] || { periodDurationInPayrolls: 12 };
  const { periodDurationInPayrolls } = targetBag;
  const consumableFrom = new Date();
  renderDeliverBagToEmployeesModal({
    initialAmount: activeBagLimitAmount,
    consumableFrom,
    periodDurationInPayrolls,
    onConfirm: async ({ date, amount }) => {
      try {
        renderDeliverBagToEmployeesModal({
          isLoading: true,
          initialAmount: amount,
          consumableFrom: date,
          periodDurationInPayrolls,
        });
        await onConfirm();
        const allEmployees = await findEmployeesWithFields({ companyId });
        const notRemovedEmployees = allEmployees.filter(
          (e) => e.state !== "removed"
        );
        const resultantEmployees = employeesToIncludeInBag.reduce(
          (acc, curr) => {
            const employee = notRemovedEmployees.find(
              ({ email }) => email === curr
            );
            if (employee) {
              return [...acc, employee];
            }
            return acc;
          },
          []
        );
        await Promise.all(
          activeBags.map(async ({ benefitBagConfigId }) => {
            await addEmployeesToModelThatHasBag({
              companyId,
              benefitPlanId: targetModel.id,
              benefitBagConfigId,
              consumableFrom: moment(date).format("YYYY-MM-DD"),
              limitAmount: amount,
              employeeIds: resultantEmployees.map(({ id }) => id),
            });
          })
        );
        hideModal();
        navigateWhenDoneTo();
      } catch (err) {
        showErrorMessage(t("common-messages.basic-error-message"), true);
      }
    },
  });
}
